module.exports = __webpack_public_path__ + "static/handmade-hobbies1-2a20a25722a8ec5280cd94c53486643c.png";